export const urls = {
  links: {
    questionAttachment(issueId: number, questionId: number, elementId: number) {
      return `/vendor/api/issue/${issueId}/question/${questionId}/attachment/${elementId}`
    },
    issueAttachment(issueId: number, attachmentId: number) {
      return `/vendor/api/issue/${issueId}/attachment/${attachmentId}`
    },
    uploadIssueAttachment(issueId: number) {
      return `/vendor/api/issue/${issueId}/attachment`
    },
    answerAttachment(issueId: number, elementId: number) {
      return `/vendor/api/issue/${issueId}/answer/attachment/${elementId}`
    },
    uploadAnswerAttachment(issueId: number) {
      return `/vendor/api/issue/${issueId}/answer/attachment`
    },
  },
}
